/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 07/12/2013
 * Time: 12:41
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services')
    .factory('DateSrv',[ "$locale", function ($locale) {
        let dateSrv = {
            daysOfWeekLabel: [$locale.DATETIME_FORMATS.DAY[1],$locale.DATETIME_FORMATS.DAY[2],$locale.DATETIME_FORMATS.DAY[3],$locale.DATETIME_FORMATS.DAY[4],$locale.DATETIME_FORMATS.DAY[5],$locale.DATETIME_FORMATS.DAY[6],$locale.DATETIME_FORMATS.DAY[0]],
            DEFAULT_BIRTHDAY_YEAR: new Date().getFullYear() - 20
        };

        dateSrv.daysOfWeekLabelC = [];
        for (let i = 0; i < dateSrv.daysOfWeekLabel.length; i++) {
            dateSrv.daysOfWeekLabelC.push(dateSrv.daysOfWeekLabel[i].charAt(0).toUpperCase() + dateSrv.daysOfWeekLabel[i].slice(1) )
        }

        dateSrv.daysBetween = function (date1, date2) {
            if (!date1 || !date2) {
                return 0;
            }

            // The number of milliseconds in one day
            let ONE_DAY = 1000 * 60 * 60 * 24;

            // Convert both dates to milliseconds
            let date1_ms = date1.getTime();
            let date2_ms = date2.getTime();

            // Calculate the difference in milliseconds
            let difference_ms = Math.abs(date1_ms - date2_ms);

            // Convert back to days and return
            return Math.round(difference_ms/ONE_DAY);
        };

        dateSrv.doReload = function() {
            dateSrv.daysOfWeekLabel = [$locale.DATETIME_FORMATS.DAY[1],$locale.DATETIME_FORMATS.DAY[2],$locale.DATETIME_FORMATS.DAY[3],$locale.DATETIME_FORMATS.DAY[4],$locale.DATETIME_FORMATS.DAY[5],$locale.DATETIME_FORMATS.DAY[6],$locale.DATETIME_FORMATS.DAY[0]];

            dateSrv.daysOfWeekLabelC = [];
            for (let i = 0; i < dateSrv.daysOfWeekLabel.length; i++) {
                dateSrv.daysOfWeekLabelC.push(dateSrv.daysOfWeekLabel[i].charAt(0).toUpperCase() + dateSrv.daysOfWeekLabel[i].slice(1))
            }
            return dateSrv;
        };

        return dateSrv;
    }]);

angular.module('FlexyBeautyApp.services')
    .factory('Format',[ function () {
        let format = {};

        format.formatNumber = function(input) {
            let output;

            if(input != undefined && input != "") {
                if(input[0] == "+") {
                    output = input;
                } else {
                    let withoutSpace = input.replace(/\s/g, '');
                    withoutSpace = withoutSpace.replace(/\./g, '');//Remove also dot
                    //remove space
                    let ret = [];
                    //create a array every 2 chars
                    for (let i = 0, len = withoutSpace.length; i < len; i += 2) {
                        ret.push(withoutSpace.substr(i, 2))
                    }
                    output = ret.join(' ');//join array as string inserting a space
                }

                return output;
            }
            return input;
        };

        return format;
    }
    ]);

angular.module('FlexyBeautyApp.services')
    .factory('DateFormator',["moment", function (moment) {
        let dateFormator = {};
        const DAY_ID_FORMAT = "YYYYMMDD";

        dateFormator.format = function (idOfDay) {
            let id = idOfDay + "";
            return id.substring(6, 8) + "/" + id.substring(4, 6) + "/" + id.substring(0, 4); // returns "dd/mm/yyyy"
        };

        /**
         * @return "yyyymmdd"
         */
        dateFormator.dateToDayId = function (date) {
            return (date ? moment(date).format(DAY_ID_FORMAT) : date);
        };

        dateFormator.dayIdToDate = function (stringDate) {
            let yyyy = stringDate.substring(0, 4);
            let mm = stringDate.substring(4, 6);
            let dd = stringDate.substring(6, 8);
            return new Date(`${yyyy}/${mm}/${dd}`);
        };

        return dateFormator;
    }
]);

angular.module('FlexyBeautyApp.services')
    .factory('StyleColor',[ function () {
        let styleColor = {};

        styleColor.getContrastYIQ = function (hexcolor){
            var r = parseInt(hexcolor.substr(1,2),16);
            var g = parseInt(hexcolor.substr(3,2),16);
            var b = parseInt(hexcolor.substr(5,2),16);
            var yiq = ((r*299)+(g*587)+(b*114))/1000;
            return (yiq >= 128) ? 'black' : 'white';
        };

        return styleColor;
    }
]);

angular.module('FlexyBeautyApp.services')
    .factory('Theme',[ function () {
        let theme = {};

        let themeCollection = new Array();

        themeCollection["blue"] = {
            name : "blue",
            file :"./dist/css/blue-theme.css"
        };
        themeCollection["pink"] = {
            name : "pink",
            file :"./dist/css/pink-theme.css"
        };
        themeCollection["green"] = {
            name : "green",
            file :"./dist/css/green-theme.css"
        };
        themeCollection["pink-original"] = {
            name : "pink-original",
            file :"./dist/css/pink-original-theme.css"
        };

        theme.getThemeByName = function (name){
            return themeCollection[name] ? themeCollection[name]:themeCollection["pink-original"];
        };

        return theme;
    }
]);

angular.module('FlexyBeautyApp.services')
    .factory('Timers',["$timeout", "$interval", function ($timeout, $interval) {
        return {
            cancel: function (timers, intervals) {
                if (timers && timers.length) {
                    timers.forEach((timer) => {
                        if (timer) {
                            $timeout.cancel(timer);
                        }
                    });
                }
                if (intervals && intervals.length) {
                    intervals.forEach((interval) => {
                        if (interval) {
                            $interval.cancel(interval);
                        }
                    });
                }
            }
        };
    }
]);


// WEBPACK FOOTER //
// ./js/services/tools/tools.js